module.exports = {
  caseClosedDate: '退货单完成时间',
  packageType: '包裹是否异常',
  whReceiveDate: '仓库签收时间',
  channel: '平台',
  caseClosed: '完成单量',
  processLt: '处理时效',
  abnormalRatio: '异常件比例',
  timeRange: 'Time Range',
  returnGrade: 'Return Grade',
  returnOrderInStockStatus: '退货单在库状态',
  isGreenChannel: '是否绿通',
  warehouseEfficiencyTitle: '仓库处理时效',
  returnShelfTime: '退货上架时效',
  abnormal: '异常件',
  nonAbnormal: '非异常件',
  rcvCs: 'RCV→CS',
  rcvCsTitle: '仓库签收 - 异常工单创建',
  csHandling: 'CS Handling',
  csHandlingTitle: '异常工单创建 - 拒收/入库反馈',
  csDcClose: 'CS→DC Close',
  csDcCloseTitle: '拒收/入库反馈 - ASN收货完成/拒收',
  abnormalTypeTitle: '异常种类',
  abnormalOrderNum: '异常订单数',
  abnormalPercent: '异常占比',
  abnormalReason: '异常原因分布图'
}
